<template>
  <scout-form
    :is-modified="!!hasCareerResumes || !!excludesDisabledScout || !!includesResend"
    :half="half"
    label="その他"
  >
    <div class="boss-layout boss-layout-start">
      <label
        v-if="hasCareerResumes !== undefined"
        class="boss-checkbox"
        data-test="has-career-resumes"
      >
        <input
          :checked="hasCareerResumes"
          class="boss-input-checkbox"
          type="checkbox"
          @change="$emit('update:hasCareerResumes', $event.target.checked)"
        >「職務経歴」登録済みのみ
      </label>
      <label
        v-if="excludesDisabledScout !== undefined"
        class="boss-checkbox"
        data-test="excludes-disabled-scout"
      >
        <input
          :checked="excludesDisabledScout"
          type="checkbox"
          class="boss-input-checkbox"
          @change="$emit('update:excludesDisabledScout', $event.target.checked)"
        >アプローチ不可能な会員を表示しない
      </label>
      <label
        v-if="includesResend !== undefined"
        class="boss-checkbox"
        data-test="includes-resend"
      >
        <input
          :checked="includesResend"
          type="checkbox"
          class="boss-input-checkbox"
          @change="$emit('update:includesResend', $event.target.checked)"
        >本日配信不可能な会員を表示しない
      </label>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'

export default {
  components: {
    ScoutForm
  },
  props: {
    hasCareerResumes: {
      default: undefined,
      type: Boolean
    },
    excludesDisabledScout: {
      default: undefined,
      type: Boolean
    },
    includesResend: {
      default: undefined,
      type: Boolean
    },
    half: {
      default: false,
      type: Boolean
    }
  }
}
</script>
